// extracted by mini-css-extract-plugin
module.exports = {"pageMaxWidth":"pageMaxWidth__wD1Db","carouselMaxWidth":"carouselMaxWidth__1VVP_","showSlide":"showSlide__2NAN9"};